import { render } from "./AnagraficaLeadCaldi.vue?vue&type=template&id=3cf5c540&scoped=true"
import script from "./AnagraficaLeadCaldi.vue?vue&type=script&lang=js"
export * from "./AnagraficaLeadCaldi.vue?vue&type=script&lang=js"

import "./AnagraficaLeadCaldi.vue?vue&type=style&index=0&id=3cf5c540&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf5c540"]])

export default __exports__